







import { Component, Vue } from 'vue-property-decorator';

// components
import NavBlock from './components/NavBlock.vue';
import MainBlock from './components/MainBlock.vue'

// icon-font css
require('./assets/icons/icons.css')

@Component({
  components: {
    NavBlock,
    MainBlock
  }
})
export default class App extends Vue {

  // async mounted() {
  //   await this.$store.dispatch('GETTASK')
  // }

  get navList() {
    return this.$store.state.navList
  }

}
